Vue.component('viewerKeys', {
  template: templates.viewerKeys,
  data() {
    return {
      model: {
        keys: []
      }
    }
  },
  mounted() {
    const c = this;
    c.getKeys();

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="viewer-keys"] > .key', function(e) {
      c.show($(this).clone());
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-element', function() {
      c.hide();
    });
  },
  methods: {
    getKeys() {
      const c = this;
      //let keys = [];

      userService.getKeys()
        .then(function (response) {
          //keys = response.data;
          for (let key of response.data) {
            key.image = `${root}/images/keys/${key.id}.png`;
            if (key.uses == 0) {
              key.uses = 'Unlimited';
            }
          }
          c.model.keys = response.data;
        })
        .catch(function (error) {
          
        });
    },
    show($element) {
      let id = $element.data('id');
      let video = `/videos/keys/${id}.webm`;

      var testEl = document.createElement( "video" ), webm;
      if ( testEl.canPlayType ) {
          // Check for Webm support
          webm = "" !== testEl.canPlayType( 'video/webm; codecs="vp8, vorbis"' );
          if (webm) {
            $element.find('img').replaceWith(`<video src="${video}" class="video-overlay__video key" loop muted autoplay playsinline></video>`);
          }
      }

      //let description = $card.find('.bottom > div:first-of-type').data('description');
      $element.find('.description').attr('class', '');
      $('.view-element > div').append($element);
      $('.view-element').addClass('is-above').addClass('is-visible');
    },
    hide() {
      $('.view-element').removeClass('is-visible');
      setTimeout(function() {
        $('.view-element').removeClass('is-above');
        $('.view-element > div').html('');
      }, 300);
    }
  }
});